import React from 'react';
import { Global, css } from '@emotion/core';
import clearSans from './fonts/ClearSans.woff2';
import clearSansMedium from './fonts/ClearSans-Medium.woff2';
import clearSansBold from './fonts/ClearSans-Bold.woff2';
import dunbarTallExtraLight from './fonts/DunbarTall-ExtraLight.woff2';
import dunbarTallLight from './fonts/DunbarTall-Light.woff2';
import dunbarTallBook from './fonts/DunbarTall-Book.woff2';
import dunbarTallRegular from './fonts/DunbarTall-Regular.woff2';
import dunbarTallMedium from './fonts/DunbarTall-Medium.woff2';
import dunbarTallBold from './fonts/DunbarTall-Bold.woff2';
import dunbarTallExtraBold from './fonts/DunbarTall-ExtraBold.woff2';
import dunbarTallUltra from './fonts/DunbarTall-Ultra.woff2';
import { Css } from '../ui';
import { theme } from './theme';

export const FONT_FAMILY_CLEAR_SANS = 'Clear Sans';
export const FONT_FAMILY_DUNBAR_TALL = 'Dunbar Tall';

export const customFonts = [
	{
		family: FONT_FAMILY_CLEAR_SANS,
		url: clearSans,
		format: 'woff2',
		weight: 400,
	},
	{
		family: FONT_FAMILY_CLEAR_SANS,
		url: clearSansMedium,
		format: 'woff2',
		weight: 500,
	},
	{
		family: FONT_FAMILY_CLEAR_SANS,
		url: clearSansBold,
		format: 'woff2',
		weight: 700,
	},
	// DUNBAR TALL
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallExtraLight,
		format: 'woff2',
		weight: 100,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallLight,
		format: 'woff2',
		weight: 200,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallBook,
		format: 'woff2',
		weight: 300,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallRegular,
		format: 'woff2',
		weight: 400,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallMedium,
		format: 'woff2',
		weight: 500,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallBold,
		format: 'woff2',
		weight: 700,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallExtraBold,
		format: 'woff2',
		weight: 800,
	},
	{
		family: FONT_FAMILY_DUNBAR_TALL,
		url: dunbarTallUltra,
		format: 'woff2',
		weight: 900,
	},
];

export function Font() {
	const customFontFaceStyles = customFonts.map(
		({ family, url, format, weight }) => css`
			@font-face {
				font-family: ${family};
				src: url(${url}) format(${format});
				font-display: swap;
				${weight && `font-weight: ${weight};`}
			}
		`,
	);

	const styles = css`
		body {
			-webkit-font-smoothing: antialiased;
		}

		a {
			line-height: normal;
			font-weight: 500;
		}

		.overline {
			text-transform: uppercase;
			font-weight: 700;
			font-size: ${Css.pxToRem(12)};
		}

		.caption {
			font-weight: 400;
			font-size: ${Css.pxToRem(12)};
		}
		.large {
			line-height: ${Css.pxToRem(26)};
			font-weight: 400;
			font-size: ${Css.pxToRem(18)};
		}
		.small {
			font-size: ${theme.typography?.small?.size};
		}

		${customFontFaceStyles}
	`;

	return <Global styles={styles} />;
}
